// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */

import { Box, Icon, Typography } from "@outschool/backpack";
import { fasBookmark, fasHeart } from "@outschool/icons";
import { savedClassesPath, savedSearchesPath } from "@outschool/routes";
import { useSession } from "@outschool/ui-auth";
import { TrackedButton } from "@outschool/ui-components-shared";
import {
  ActivityListing,
  useSavedActivitiesCount,
  useSavedSearchesCount
} from "@outschool/ui-components-website";
import { useLinkComponent } from "@outschool/ui-utils";
import React, { useRef } from "react";

import { pickSectionSearchFilters } from "../../../../shared/Section";
import { CARD_WIDTH } from "../../listings/constants";
import { ListingsProp } from "../common";
import { GetClassRecommendationsChatButton } from "../GetClassRecommendations";

export function SavedActivitiesLinkMobile() {
  const Link = useLinkComponent();
  const savedActivitiesCount = useSavedActivitiesCount();
  return savedActivitiesCount ? (
    <TrackedButton
      variant="link"
      component={Link}
      to={savedClassesPath()}
      trackingName="activity_listings_link_saved_classes"
      sharedProperties={{ savedActivitiesCount }}
    >
      <Icon
        icon={fasHeart}
        sx={{
          marginRight: "0.5em",
          fontSize: "16px"
        }}
      />
      <Typography
        variant="inherit"
        sx={{
          fontWeight: "fontWeightMedium"
        }}
      >
        ({savedActivitiesCount})
      </Typography>
    </TrackedButton>
  ) : null;
}

export function SavedSearchesLinkMobile() {
  const Link = useLinkComponent();
  const savedSearchesCount = useSavedSearchesCount();
  return savedSearchesCount ? (
    <TrackedButton
      variant="link"
      component={Link}
      to={savedSearchesPath()}
      trackingName="activity_listings_link_saved_searches"
      sharedProperties={{ savedSearchesCount }}
    >
      <Icon
        icon={fasBookmark}
        sx={{
          marginRight: "0.5em",
          fontSize: "16px"
        }}
      />
      <Typography
        variant="inherit"
        sx={{
          fontWeight: "fontWeightMedium"
        }}
      >
        ({savedSearchesCount})
      </Typography>
    </TrackedButton>
  ) : null;
}

export function ListingsWrapperMobile({
  listings,
  // @ts-ignore TS(2339): Property 'startIndex' does not exist on type '{ st... Remove this comment to see the full error message
  tracking: { startIndex = 0, filters = {}, searchUid, group, numPopular = 0 },
  disabled = false
}: ListingsProp) {
  const loadingMessageRef = useRef();
  const sectionSearchFilters = pickSectionSearchFilters(filters);
  const hasFilters =
    filters && Object.values(filters).some(value => value !== undefined);
  const { isLoggedIn } = useSession();

  const hasListingsAndFilters = listings.length > 1 && hasFilters;
  return (
    <Box
      sx={(theme: $TSFixMe) => ({
        display: "block",
        gridTemplateColumns: `repeat(auto-fill, minmax(${CARD_WIDTH}px, 1fr))`,
        gap: "1em",
        [theme.breakpoints.up("sm")]: {
          gap: "2em"
        },
        marginBottom: "1em"
      })}
    >
      {listings.map((listing, index) => {
        return (
          <Box key={listing.activity.uid}>
            <ActivityListing
              listing={listing}
              // @ts-ignore TS(2322): Type 'SectionSearchFilters | null' is not assignab... Remove this comment to see the full error message
              sectionSearchFilters={sectionSearchFilters}
              trackingProperties={{
                searchUid,
                group,
                order: startIndex + index + 1,
                isPopular: (index < numPopular).toString(),
                rank_strategy: listing.strategy,
                rank_es_score: listing.score,
                rank_strategy_score: listing.strategyScore,
                rank_randomized_score: listing.strategy?.startsWith(
                  "popular_ranking"
                )
                  ? // @ts-ignore TS(2531): Object is possibly 'null'.
                    listing.score - listing.strategyScore
                  : null
              }}
              disabled={disabled}
              openInSSRForLoggedOutUsers={!isLoggedIn}
              pageLocation="MOBILE_LISTING"
            />
          </Box>
        );
      })}

      {!!hasListingsAndFilters && isLoggedIn && (
        <GetClassRecommendationsChatButton />
      )}
      {/* @ts-ignore TS(2322): Type 'MutableRefObject<undefined>' is not assignab... Remove this comment to see the full error message */}
      <div key="lazy-listings-loading-more" ref={loadingMessageRef} />
    </Box>
  );
}
